<div class="c-navigation__wrapper" (mouseleave)="openSubNavigation()">
  <nav
    class="c-navigation"
    [class.c-navigation--open]="isSubNavigationOpen$ | async"
  >
    <a
      routerLink="/dashboard"
      class="c-navigation__logo"
      title="Lightspeed Restaurant"
      (click)="stopEventPropagation($event)"
      (mouseenter)="closeSubNavigationOnHover()"
    >
      <img src="./assets/img/logos/lightspeed-white-One-LS.svg" alt="" />
      <img
        src="./assets/img/logos/lightspeed-symbol-One-LS.svg"
        class="c-navigation__logo--open"
        alt=""
      />
    </a>

    <ul
      class="o-list c-navigation__links"
      (mouseenter)="closeSubNavigationOnHover()"
    >
      <ng-container *ngFor="let route of (routes$ | async)">
        <li *ngIf="(resolveRoute(route) | async)">
          <a
            class="c-navigation__link"
            data-title="{{ route.path }}"
            [ngClass]="{
              'contains--pill':
                outDatedDevicesCount > 0 && route.path === 'devices'
            }"
            [routerLink]="route.path"
            routerLinkActive="c-navigation__link--active"
            (click)="stopEventPropagation($event)"
            id="{{ route.title }}"
          >
            <img src="./assets/img/icons/{{ route.icon }}" alt="" />
            <span>{{ route.title | lsTranslate }}</span>
            <i class="fa fa-caret-right" *ngIf="route.children"></i>
            <ls-pill
              *ngIf="outDatedDevicesCount > 0 && route.title === 'Devices'"
              [count]="outDatedDevicesCount"
              [pillColorStyle]="outDatedDevicesPillStyle"
            ></ls-pill>
          </a>
        </li>
      </ng-container>
    </ul>

    <div class="c-navigation__subnav">
      <h4>{{ title | lsTranslate }}</h4>

      <ul class="o-list">
        <ng-container *ngFor="let route of (childRoutes$ | async)">
          <li *ngIf="(resolveRoute(route) | async)">
            <a
              [routerLink]="[buildRoute(route)]"
              routerLinkActive="c-navigation__link--active"
              [routerLinkActiveOptions]="{ exact: false }"
              (click)="stopEventPropagation($event)"
              class="c-navigation__link"
            >
              <span *ngIf="route.title" id="{{ route.title }}">{{
                route.title | lsTranslate
              }}</span>
            </a>
          </li>
        </ng-container>
        <div id="categorybar" *ngIf="layouts && layouts.length > 0">
          <li *ngFor="let layout of layouts">
            <a
              class="c-navigation__link categorybar-link"
              routerLinkActive="active"
              (click)="stopEventPropagation($event)"
              [class.category]="!layout.isShortCutCategory()"
              [class.categoryLayout]="layout.isShortCutCategory()"
              [routerLink]="'/products/layout/' + layout.getId()"
              [class.u-opacity-30]="!layout.isVisible()"
            >
              <img ls-image [src]="layout.getImage()" />
              <span class="name">
                {{ layout.getName() }}
              </span>

              <div class="pill pill-info">
                {{ layout.getProducts().length }}
              </div>
            </a>
          </li>
        </div>
      </ul>
    </div>

    <div class="c-navigation__footer">
      <ul
        class="o-list c-navigation__dropdown-items"
        [class.open]="expandedEstablishmentDropdown"
      >
        <li
          (click)="changeEstablishment(establishment)"
          *ngFor="let establishment of establishments"
          class="c-navigation__link"
        >
          {{ establishment.name }}
        </li>
      </ul>
      <div
        class="c-navigation__dropdown"
        *ngIf="showEstablishments()"
        (click)="toggleDropdown(establishments)"
        [class.c-navigation__dropdown--active]="expandedEstablishmentDropdown"
        [class.c-navigation__dropdown--single]="establishments.length === 1"
      >
        <img
          src="./assets/img/icons/icon-restaurant.svg"
          alt=""
          class="u-align-middle"
        />
        <span class="u-align-middle">
          <label *ngIf="selectedEstablishment.isMaster">M</label>
          <span>{{ selectedEstablishment.name }}</span>
          <small>{{ displayNameLoggedinUser$ | async }}</small>
        </span>
        <i class="fa fa-caret-up" aria-hidden="true"></i>
      </div>
      <div class="c-navigation__footer--links">
        <div class="c-navigation__footer--link" (click)="toggleHelp()">
          <img src="./assets/img/icons/icon-chat.svg" alt="" />
        </div>
        <a
          routerLink="/account"
          class="c-navigation__footer--link"
          (click)="handleAccountIconClick($event)"
          routerLinkActive="is-active"
        >
          <img src="./assets/img/icons/icon-users.svg" alt="" />
        </a>
        <a (click)="logout()" id="lkLogout" class="c-navigation__footer--link">
          <img src="./assets/img/icons/icon-logout.svg" alt="" />
        </a>
      </div>
    </div>
  </nav>
</div>
<ls-spinner-loader *ngIf="canSpin()"></ls-spinner-loader>

<div
  ls-dynamic-translation
  id="Dashboard"
  i18n="Routing|Route name for dashboard @@navigationDashboard"
>
  Dashboard
</div>

<!-- Start: Reports navigation -->
<div
  ls-dynamic-translation
  id="Reports"
  i18n="Navigation|Navigation to reports @@navigationReports"
>
  Reports
</div>

<!-- Start: Reports sub navigation -->

<div
  ls-dynamic-translation
  id="Receipts"
  i18n="Navigation|Navigation to receipts reports @@navigationReceiptsReport"
>
  Receipts
</div>

<div
  ls-dynamic-translation
  id="Labour Reports"
  i18n="Navigation|Navigation to labour reports @@navigationLabourReports"
>
  Labour Reports
</div>

<div
  ls-dynamic-translation
  id="Hour Reports"
  i18n="Navigation|Navigation to hour reports @@navigationHourReports"
>
  Hour Reports
</div>

<div
  ls-dynamic-translation
  id="Day Reports"
  i18n="Navigation|Navigation to day reports @@navigationDayReports"
>
  Day Reports
</div>

<div
  ls-dynamic-translation
  id="Week Reports"
  i18n="Navigation|Navigation to week reports @@navigationWeekReports"
>
  Week Reports
</div>

<div
  ls-dynamic-translation
  id="Month Reports"
  i18n="Navigation|Navigation to month reports @@navigationMonthReports"
>
  Month Reports
</div>
<div
  ls-dynamic-translation
  id="Closing reports"
  i18n="Navigation|Navigation to closing reports @@navigationClosingReports"
>
  Closing reports
</div>

<div
  ls-dynamic-translation
  id="Product Reports"
  i18n="Navigation|Navigation to device reports @@navigationProductReports"
>
  Product Reports
</div>

<div
  ls-dynamic-translation
  id="Category Reports"
  i18n="Navigation|Navigation to category reports @@navigationCategoryReports"
>
  Category Reports
</div>

<div
  ls-dynamic-translation
  id="User Reports"
  i18n="Navigation|Navigation to user reports @@navigationUserReports"
>
  User Reports
</div>

<div
  ls-dynamic-translation
  id="Revenue Reports"
  i18n="Navigation|Navigation to revenue reports @@navigationRevenueReports"
>
  Revenue Reports
</div>

<div
  ls-dynamic-translation
  id="Ingredients Reports"
  i18n="Navigation|Navigation to ingredient reports @@navigationIngredientsReports"
>
  Ingredients Reports
</div>

<div
  ls-dynamic-translation
  id="Shift Reports"
  i18n="Navigation|Navigation to shift reports @@navigationShiftReports"
>
  Shift Reports
</div>

<div
  ls-dynamic-translation
  id="IRS Reports"
  i18n="Navigation|Navigation to irs reports @@navigationIrsReports"
>
  IRS Reports
</div>

<div
  ls-dynamic-translation
  id="Z Reports"
  i18n="Navigation|Navigation to z reports @@navigationZReports"
>
  Z Reports
</div>

<div
  ls-dynamic-translation
  id="Advanced Reports"
  i18n="Navigation|Navigation to advanced reports @@navigationAdvancedReports"
>
  Advanced Reports
</div>

<!-- End: Reports sub navigation -->
<!-- End: Reports navigation -->

<!-- Start: Establishment Reports navigation -->

<div
  ls-dynamic-translation
  id="Location Reports"
  i18n="Navigation|Navigation name for location reports @@navigationLocationReports"
>
  Location Reports
</div>

<!-- Start: Establishment Reports sub navigation -->

<div
  ls-dynamic-translation
  id="Location Revenue"
  i18n="Navigation|Link to combined location revenue @@navigationCombinedLocationRevenue"
>
  Location Revenue
</div>

<div
  ls-dynamic-translation
  id="All Receipts"
  i18n="Navigation|Link to combined receipts report @@navigationCombinedReceiptsReport"
>
  All Receipts
</div>

<div
  ls-dynamic-translation
  id="All Day Reports"
  i18n="Navigation|Link to combined day report @@navigationCombinedDayReport"
>
  All Day Reports
</div>

<div
  ls-dynamic-translation
  id="All Week Reports"
  i18n="Navigation|Link to combined week report @@navigationCombinedWeekReport"
>
  All Week Reports
</div>

<div
  ls-dynamic-translation
  id="All Month Reports"
  i18n="Navigation|Link to combined month report @@navigationCombinedMonthReport"
>
  All Month Reports
</div>

<div
  ls-dynamic-translation
  id="All Products Reports"
  i18n="Navigation|Link to combined product report @@navigationCombinedProductReport"
>
  All Products Reports
</div>

<div
  ls-dynamic-translation
  id="All Categories Reports"
  i18n="Navigation|Link to combined category report @@navigationCombinedCatgoryReport"
>
  All Categories Reports
</div>

<div
  ls-dynamic-translation
  id="All Users Reports"
  i18n="Navigation|Link to combined users report @@navigationCombinedUserReport"
>
  All Users Reports
</div>

<div
  ls-dynamic-translation
  id="All Revenue Reports"
  i18n="Navigation|Link to combined revenue report @@navigationCombinedRevenueReport"
>
  All Revenue Reports
</div>

<!-- End: Establishment Reports navigation -->
<!-- End: Establishment Reports navigation -->

<!-- Start: User navigation -->

<div
  ls-dynamic-translation
  id="Users"
  i18n="Routing|Route name for dashboard @@navigationUsers"
>
  Users
</div>

<!-- Start: Users Sub navigation -->

<div
  ls-dynamic-translation
  id="User Groups"
  i18n="Navigation|Navigation to user groups @@navigationUserGroups"
>
  User Groups
</div>

<div
  ls-dynamic-translation
  id="Customers"
  i18n="Navigation|Navigation to customers @@navigationCustomers"
>
  Customers
</div>

<div
  ls-dynamic-translation
  id="Invoices"
  i18n="Navigation|Navigation to customers @@navigationInvoices"
>
  Invoices
</div>

<!-- End: Users Sub navigation -->
<!-- End: User navigation -->

<!-- Start: Products navigation -->

<div
  ls-dynamic-translation
  id="Products"
  i18n="Navigation|Navigation to products @@navigationProducts"
>
  Products
</div>

<div
  ls-dynamic-translation
  id="Modifiers"
  i18n="Navigation|Navigation to Modifiers @@navigationModifiers"
>
  Modifiers
</div>

<div
  ls-dynamic-translation
  id="Timed Events"
  i18n="Navigation|Navigation to timed events @@navigationTimedEvents"
>
  Timed Events
</div>

<div
  ls-dynamic-translation
  id="Categories"
  i18n="Navigation|Navigation to category @@navigationCategories"
>
  Categories
</div>

<div
  ls-dynamic-translation
  id="Ingredients"
  i18n="Navigation|Navigation to ingredients @@navigationIngredients"
>
  Ingredients
</div>

<!-- End: Products Sub navigation -->
<!-- End: Product navigation -->

<!-- Start: Floor navigation -->

<div
  ls-dynamic-translation
  id="Floors"
  i18n="Navigation|Navigation to floors @@navigationFloors"
>
  Floors
</div>

<!-- End: Floor navigation -->

<!-- Start: Devices navigation -->

<div
  ls-dynamic-translation
  id="Devices"
  i18n="Navigation|Navigation to devices @@navigationDevices"
>
  Devices
</div>

<!-- Start: Devices Sub Navigation -->

<div
  ls-dynamic-translation
  id="Restaurant App Settings"
  i18n="Navigation|Navigation to device settings @@navigationRestaurantAppSettings"
>
  Restaurant App Settings
</div>

<div
  ls-dynamic-translation
  id="Cfd App Settings"
  i18n="Navigation|Navigation to cfd settings @@navigationCfdAppSettings"
>
  Cfd App Settings
</div>

<div
  ls-dynamic-translation
  id="Kitchen App Settings"
  i18n="Navigation|Navigation to kitchen settings @@navigationKitchenAppSettings"
>
  Kitchen App Settings
</div>

<!-- End: Devices Sub Navigation -->
<!-- End: Devices navigation -->

<!-- Start: Printing navigation -->

<div
  ls-dynamic-translation
  id="Printers"
  i18n="Navigation|Navigation to printers @@navigationPrinters"
>
  Printers
</div>

<!-- Start: Printing Sub Navigation -->

<div
  ls-dynamic-translation
  id="Printer Templates"
  i18n="Navigation|Navigation to printer templates @@navigationPrinterTemplates"
>
  Printer Templates
</div>

<div
  ls-dynamic-translation
  id="Cash Drawers"
  i18n="Navigation|Navigation to cash drawers @@navigationCashDrawers"
>
  Cash Drawers
</div>

<!-- End: Printing Sub Navigation -->
<!-- End: Printing navigation -->

<!-- Start: Payments Navigation -->

<div
  ls-dynamic-translation
  id="Payments"
  i18n="Navigation|Navigation to printers @@navigationPayments"
>
  Payments
</div>

<!-- Start: Payments Sub Navigation -->

<div
  ls-dynamic-translation
  id="Payment Types"
  i18n="Navigation|Navigation to payment types @@navigationPaymentTypes"
>
  Payment Types
</div>

<div
  ls-dynamic-translation
  id="Payment Processors"
  i18n="Navigation|Navigation to payment processors @@navigationPaymentProcessors"
>
  Payment Processors
</div>

<div
  ls-dynamic-translation
  id="Payment Terminals"
  i18n="Navigation|Navigation to payment terminal @@navigationPaymentTerminals"
>
  Payment Terminals
</div>

<div
  ls-dynamic-translation
  id="Payment Processing"
  i18n="Navigation|Navigation to payment processing @@navigationPaymentProcessing"
>
  Payment Processing
</div>

<div
  ls-dynamic-translation
  id="Gift Card"
  i18n="Navigation|Navigation to gift cards @@navigationGiftCards"
>
  Gift Card
</div>

<div
  ls-dynamic-translation
  id="Gift card Transactions"
  i18n="Navigation|Navigation to gift card transactions @@navigationGiftCardTransactions"
>
  Gift card Transactions
</div>

<!-- End: Payments Sub Navigation -->
<!-- End: Payments navigation -->
<!-- Start: Financial Services Navigation -->

<div
  ls-dynamic-translation
  id="Financial Services"
  i18n="Navigation|Navigation to financial services @@navigationFincialServices"
>
  Financial Services
</div>

<!-- Start: Financial Services Sub Navigation -->

<div
  ls-dynamic-translation
  id="Financial Services"
  i18n="Navigation|Navigation to financial services @@navigationFincialServices"
>
  Financial Services
</div>

<div
  ls-dynamic-translation
  id="Lightspeed Capital"
  i18n="Navigation|Navigation to ls-capital @@navigationLsCapital"
>
  Lightspeed Capital
</div>

<!-- End: Financial Services Sub Navigation -->
<!-- End: Financial Services Navigation -->
<!-- Start: Settings Navigation -->

<div
  ls-dynamic-translation
  id="Settings"
  i18n="Navigation|Navigation to settings @@navigationSettings"
>
  Settings
</div>

<!-- Start: Settings Sub Navigation -->

<div
  ls-dynamic-translation
  id="Company Settings"
  i18n="Navigation|Navigation to company settings @@navigationCompanySettings"
>
  Company Settings
</div>

<div
  ls-dynamic-translation
  id="Report Settings"
  i18n="Navigation|Navigation to report settings @@navigationReportSettings"
>
  Report Settings
</div>

<div
  ls-dynamic-translation
  id="Print Settings"
  i18n="Navigation|Navigation to print settings @@navigationPrintSettings"
>
  Print Settings
</div>

<div
  ls-dynamic-translation
  id="App Settings"
  i18n="Navigation|Navigation to app settings @@navigationAppSettings"
>
  App Settings
</div>

<div
  ls-dynamic-translation
  id="Manager Settings"
  i18n="Navigation|Navigation to manager settings @@navigationManagerSettings"
>
  Manager Settings
</div>

<div
  ls-dynamic-translation
  id="Menu Settings"
  i18n="Navigation|Navigation to menu settings @@navigationMenuSettings"
>
  Menu Settings
</div>

<div
  ls-dynamic-translation
  id="Email Settings"
  i18n="Navigation|Navigation to email settings @@navigationEmailSettings"
>
  Email Settings
</div>

<div
  ls-dynamic-translation
  id="Invoice Settings"
  i18n="Navigation|Navigation to invoice settings @@navigationInvoiceSettings"
>
  Invoice Settings
</div>

<div
  ls-dynamic-translation
  id="Loyalty Settings"
  i18n="Navigation|Navigation to loyalty settings @@navigationLoyaltySettings"
>
  Loyalty Settings
</div>

<div
  ls-dynamic-translation
  id="Stock Settings"
  i18n="Navigation|Navigation to stock settings @@navigationStockSettings"
>
  Stock Settings
</div>

<div
  ls-dynamic-translation
  id="FDM Settings"
  i18n="Navigation|Navigation to fdm settings @@navigationFdmSettings"
>
  FDM Settings
</div>

<div
  ls-dynamic-translation
  id="Notification Settings"
  i18n="Navigation|Navigation to notification settings @@navigationNotificationSettings"
>
  Notification Settings
</div>

<!-- End: Settings Sub Navigation -->
<!-- End: Settings Navigation -->

<!-- Start: Support Navigation -->

<div
  ls-dynamic-translation
  id="Support Dashboard"
  i18n="Navigation|Navigation to support dashboard @@navigationSupportDashboard"
>
  Support Dashboard
</div>

<div
  ls-dynamic-translation
  id="Account Validation"
  i18n="Navigation|Navigation to account validation @@navigationAccountValidation"
>
  Account Validation
</div>
<div
  ls-dynamic-translation
  id="Tasks"
  i18n="Navigation|Navigation to tasks @@navigationTasks"
>
  Tasks
</div>

<div
  ls-dynamic-translation
  id="navigationIntegrations"
  i18n="Navigation|Navigation to integrations @@navigationIntegrations"
>
  Integrations
</div>

<!-- End: Support Navigation -->
